import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

export const PaddingContainer = styled.div`
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  }
`;

export const BodyContent = styled.div`
  min-height: 100vh;
  margin: 0;
  line-height: 100%;
  display: grid !important;
  grid-template-rows: auto 1fr auto;
`;

export const JumbotronContainer = styled.div`
  ${({ backgroundColor }) => css`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    background-color: ${backgroundColor};
    padding: 32px 0;
  `};
`;

export const JumbotronContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderContent = styled.div`
  .BaSe--header {
    > div {
      > div {
        > div {
          > div {
            justify-content: start;
          }
        }
      }
    }
  }
  ul {
    li {
      margin-right: 16px;
    }
  }
  .left-header {
    padding-left: 12px;
  }
`;

export const FooterContent = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;

  .BaSe--footer {
    .BaSe--accordion {
      display: none;
    }
    a {
      display: none;
    }
    p {
      padding: 0 10px;
    }
  }
`;
